import React, { useState } from "react";
import { useFormik } from "formik";
import { Alert, Snackbar } from "@mui/material";
import { useTranslation } from "react-i18next";

import { AddHeader } from "../../components/AddHeader";
import {
  changepassword,
  superadminchangepassword,
} from "../../components/funtionsBD/Mainservice";
import eye from "../../components/assets/eye.svg";

export const ChangePassword = () => {
  const [success, setsuccess] = useState();
  const [error, seterror] = useState();
  const [open, setOpen] = useState(false);
  const [open2, setopen2] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const userinfo = JSON.parse(localStorage.getItem("user"));

  const validate = (values) => {
    const errors = {};

    if (!values.newpassword) {
      errors.newpassword = `${t("require")}`;
    } else if (values.newpassword.length < 6) {
      errors.newpassword = `${t("must6")}`;
    } else if (values.newpassword.length > 20) {
      errors.newpassword = `${t("must20")}`;
    }
    if (!values.confpassword) {
      errors.confpassword = `${t("require")}`;
    } else if (values.newpassword !== values.confpassword) {
      errors.confpassword = `${t("notmatch")}`;
    }
    if (!values.oldpassword) {
      errors.oldpassword = `${t("require")}`;
    }
    return errors;
  };

  const closealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handlesubmit = async (values, { resetForm }) => {
    try {
      const apiurl =
        userinfo.role === "superAdmin"
          ? superadminchangepassword
          : changepassword;

      const response = await apiurl(values);
      localStorage.setItem("user", JSON.stringify(response.data.data));
      resetForm();
      setsuccess(response.data.message);
      setOpen(true);
    } catch (error) {
      seterror(error.message);
      setopen2(true);
    }
  };

  const formik = useFormik({
    initialValues: {
      oldpassword: "",
      newpassword: "",
      confpassword: "",
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      handlesubmit(values, { resetForm });
    },
  });
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div id="adminRoot">
        <AddHeader title={t("changepassword")} />
        <form className="add-exercise" onSubmit={formik.handleSubmit}>
          <div className="changepassword_input">
            <div className="input-detail">
              <label htmlFor="">{t("oldpassword")}</label>
              <input
                placeholder={t("enterold")}
                type="password"
                value={formik.values.oldpassword}
                onChange={formik.handleChange}
                name="oldpassword"
              />
            </div>
            {formik.errors.oldpassword ? (
              <div className="validation_error">
                {formik.errors.oldpassword}
              </div>
            ) : null}

            <div className="input-detail">
              <label htmlFor="">{t("newpassword")}</label>
              <div className="input-passwordfield">
                <input
                  type={showPassword ? "text" : "password"}
                  value={formik.values.newpassword}
                  onChange={formik.handleChange}
                  name="newpassword"
                  placeholder={t("enternew")}
                />
                <img
                  className={showPassword ? "hide" : ""}
                  onClick={togglePasswordVisibility}
                  src={eye}
                  alt=""
                />
              </div>
            </div>
            {formik.errors.newpassword ? (
              <div className="validation_error">
                {formik.errors.newpassword}
              </div>
            ) : null}

            <div className="input-detail">
              <label htmlFor="">{t("confirmpassword")}</label>
              <div className="input-passwordfield">
                <input
                  type="password"
                  value={formik.values.confpassword}
                  onChange={formik.handleChange}
                  name="confpassword"
                  placeholder={t("enterconfirm")}
                />
              </div>
            </div>
            {formik.errors.confpassword ? (
              <div className="validation_error">
                {formik.errors.confpassword}
              </div>
            ) : null}
          </div>

          <div className="input-detail">
            <button className="w-100" type="submit">
              {t("submit")}
            </button>
          </div>
        </form>
        <Snackbar
          open={open}
          autoHideDuration={3000}
          onClose={closealert}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert variant="filled" severity="success">
            {success}
          </Alert>
        </Snackbar>
        <Snackbar
          open={open2}
          autoHideDuration={3000}
          onClose={() => setopen2(false)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
        >
          <Alert variant="filled" severity="error">
            {error}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};
